module.exports = __webpack_public_path__ + "media/images/expert__dani-kern-c3726ab5fd9a8bd8a0720f551a95627a.png";